import { Link } from "gatsby";
import * as React from "react";
import {
  ABOUTUS_PAGE,
  CONTACT_PAGE,
  HOME_PAGE,
  LEGAL_PAGE,
  PRODUCTS_PAGE,
  SUPPORT_PAGE,
  TRIP_SUITE_HOMEPAGE,
} from "../constant/routes";

export const FooterItems = [
    {
      id: 1,
      name: "LEGAL",
      path: LEGAL_PAGE,
      isActive: false,
     
    },
    {
      id: 2,
      name: "SUPPORT",
      path: SUPPORT_PAGE,
      isActive: false,
    },
    {
      id: 4,
      name: "Blog",
      path: "https://blog.webbermill.com/",
      isActive: false,
    },
    {
      id: 5,
      name: "CONTACT SALES",
      path: CONTACT_PAGE,
      isActive: false,
    },
    {
      id: 6,
      name: "COMPANY",
      path: ABOUTUS_PAGE,
      isActive: false,
    },
  ];

export  const HumanResources = [
    {
      id: 1,
      name: "Payroll",
      path: "",
      isActive: false,
      description: "Smart and integrated payroll software to manage salaries, benefits & taxes for full, part-time and remote employees without pain.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659201/webbermill-website-assets/WSPIcons/Payroll_vft7c7.svg",
      
    },
    {
      id: 2,
      name: "Shift",
      path: "",
      isActive: false,
      description: "Build your employees' schedules in minutes and manage time off, availability and shift trade requests & engage with employees.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659200/webbermill-website-assets/WSPIcons/Shift_d9dj85.svg",
    },
    {
      id: 4,
      name: "Core HR",
      path: "",
      isActive: false,
      description: "Get smarter and more efficient software designed to make onboard, manage, and engage workers in accordance with legal and company practices.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659200/webbermill-website-assets/WSPIcons/CoreHR_uhrohk.svg",
    },
    {
      id: 5,
      name: "Recruitment",
      path: "",
      isActive: false,
      description: "Smart recruitment software for human resource departments & recruitment agencies to source & hire in the most effective way.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659204/webbermill-website-assets/WSPIcons/Recruitment_dhuqlk.svg",
    },
    {
      id: 6,
      name: "Employees",
      path: "",
      isActive: false,
      description: "Deliver quick, consistent, and intelligent HR services to every employee. Scalable and unified app that makes it easy to manage requests. and for employees to find answers.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659201/webbermill-website-assets/WSPIcons/Employees_vzisje.svg",
    },
    {
      id: 7,
      name: "Attendance",
      path: "",
      isActive: false,
      description: "Put in place a robust solution that truly manage employee attendance and automatically calculate benefit hourly, daily and monthly.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659200/webbermill-website-assets/WSPIcons/Attendance_ojs9iy.svg",
    },
  ];

export  const finance = [
    {
      id: 1,
      name: "Invoicing",
      path: "",
      isActive: false,
      description: "Create & send professional standard, retainer and recurring invoices automatically based on sales orders that gets you paid faster.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659203/webbermill-website-assets/WSPIcons/Invoice_uxfzlh.svg",
    },
    {
      id: 2,
      name: "Expenses",
      path: "",
      isActive: false,
      description: "Streamline corporate travel, automate expense reporting, gain complete control over spending, and get crucial financial insights to stay two steps ahead.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659203/webbermill-website-assets/WSPIcons/Expenses_t8nl6t.svg",
    },
    {
      id: 4,
      name: "Accounting",
      path: "",
      isActive: false,
      description: "Accounting software that manages your finances, automates business workflows, and helps you work collectively across departments.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659200/webbermill-website-assets/WSPIcons/Accounting_d8cxas.svg",
    },
  ];

export  const inventory = [
    {
      id: 1,
      name: "Stock",
      path: "",
      isActive: false,
      description: "Track every stock move from purchase to warehouse to sales. Get the most efficient stocking method and improve all your internal operations.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659201/webbermill-website-assets/WSPIcons/Inventory_mmblgf.svg",
    },
    {
      id: 2,
      name: "Purchases",
      path: "",
      isActive: false,
      description: "Simple purchase order management software for growing businesses. Manage suppliers, create and send purchase tenders.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659201/webbermill-website-assets/WSPIcons/Purchases_ruqzvq.svg",
    }
  ];

 export const transport = [
    {
      id: 1,
      name: "Consignment",
      path: TRIP_SUITE_HOMEPAGE,
      isActive: false,
      description: "Stay ahead with smart transportation business with 100% control of planning, collaboration and hassle-free execution tools.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659203/webbermill-website-assets/WSPIcons/Trip_ljixgz.svg",
    },
    {
      id: 2,
      name: "Fleet",
      path: "",
      isActive: false,
      description: "Manage vehicles, assign operators, service requests, equipment, fuel history, conduct routine inspections, expenses and insurance easily.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659201/webbermill-website-assets/WSPIcons/Fleet_lgsdnr.svg",
    },
    {
        id: 3,
        name: "Tire",
        path: "",
        isActive: false,
        description: "Powerful tire monitoring, intelligent analysis and premier service to optimize your fleet, your budget and your time.",
        icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659203/webbermill-website-assets/WSPIcons/Tires_ls6qxu.svg",
      }
  ];

 export const sales = [
    {
      id: 1,
      name: "Quotation",
      path: "",
      isActive: false,
      description: "Increase your conversion rate by creating & sending professional quotations with sign and online payment of your favourite payment processor.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659200/webbermill-website-assets/WSPIcons/Quotation_reyokk.svg",
    },
    {
      id: 2,
      name: "Point-of-sale",
      path: "",
      isActive: false,
      description: "Manage sales, inventory and employees with ease; engage customers and increase your revenue. Whether you have single or multiple stores, our tools help run your business.",
      icon: "https://res.cloudinary.com/webbermill/image/upload/v1679659203/webbermill-website-assets/WSPIcons/POS_xyhnhj.svg",
    }
  ];

export const FooterComponent = () => {

  return (
    <>
      <footer className="footer">
        <div className="footer__content-1">
          <div className="container contents">
            <div>
              <h1>Human Resource</h1>
              <ul>
                {HumanResources.map((item) => (
                  <li key={item.id}>
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h1>Finance</h1>
              <ul>
                {finance.map((item) => (
                  <li key={item.id}>
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h1>Inventory</h1>
              <ul>
                {inventory.map((item) => (
                  <li key={item.id}>
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h1>Transport</h1>
              <ul>
                {transport.map((item) => (
                  <li key={item.id}>
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h1>Sales</h1>
              <ul>
                {sales.map((item) => (
                  <li key={item.id}>
                    <Link to={item.path}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h1>Marketing</h1>
              <ul>
              <li>
                    <Link to="">SMS</Link>
                  </li>
              </ul>
            </div>
            <div>
              <h1>Productivity</h1>
              <ul>
              <li>
                    <Link to="">File Manager</Link>
                  </li>
                  <li>
                    <Link to="">Sign</Link>
                  </li>
                  <li>
                    <Link to="/frontdesk">Front Desk</Link>
                  </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer__content-2 ">
          <div className="container contents">
            <div>
              <Link to={HOME_PAGE}>
                <img
                  src="https://res.cloudinary.com/webbermill/image/upload/v1679656994/webbermill-website-assets/static/banner/footer-logo_rksy4p.svg"
                  alt="logo"
                  width={140}
                />
              </Link>
            </div>
            <ul>
              {FooterItems.map((item) => (
                <li key={item.id}>
                  <Link to={item.path}>{item.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};
